import React, { useState, useEffect } from 'react';
import './countersection.css';

import { FaReact, FaCode } from 'react-icons/fa';
import { FiMonitor, FiCode,FiCalendar, FiShoppingCart } from 'react-icons/fi';

const CounterSection = () => {
    const counters = [
        { icon: <FaReact />, label: 'ReactJS Projects', target: 15 },
        { icon: <FiMonitor />, label: 'Static Websites', target: 35 },
        { icon: <FiShoppingCart />, label: 'Shopify Websites', target: 45 },
        { icon: <FaCode />, label: 'Max Code Lines Written', target: 15000 },
        { icon: <FiCalendar />, label: 'Years of Experience', target: 2 },
    ];


    const [counts, setCounts] = useState(Array(counters.length).fill(0));

    useEffect(() => {
        const interval = setInterval(() => {
            setCounts(prevCounts => {
                return prevCounts.map((count, index) => {
                    const increment = Math.ceil(counters[index].target / 100);
                    return count + increment > counters[index].target ? counters[index].target : count + increment;
                });
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="counter-section">
            <h2>Lets Numbers Talk | Projects Completed</h2>
            <div className="counter-container">
                {counters.map((counter, index) => (
                    <div key={index} className="counter-item">
                        {React.cloneElement(counter.icon, { style: { fontSize: '48px' } })}
                        <h4>{counts[index]}+</h4>
                        <h6>{counter.label}</h6>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CounterSection;